<template>
    <div>
        <p class="mt-4 mb-8">
            Nossa Fonte é a Open Sans. É uma fonte open source , cheia de recursos e pensada para leitura em telas. <br>
            Você pode baixa-la no endereço a seguir: <a href="https://fonts.google.com/specimen/Open+Sans">https://fonts.google.com/specimen/Open+Sans</a>
        </p>

        <div class="flex w-1/2 justify-between">
            <div>
                <p class="text-2xs mb-2">Corpo - 10px</p>
                <p class="text-xs mb-2">Corpo - 12px</p>
                <p class="text-sm mb-2">Corpo - 14px</p>
                <p class="mb-2">Corpo - 16px</p>
                <p class="text-xl mb-2">Corpo - 20px</p>
                <p class="text-2xl">Corpo - 24px</p>
            </div>

            <div>
                <p class="text-xs font-bold mb-2">Subtítulo - 12px</p>
                <p class="text-sm font-bold mb-2">Subtítulo - 14px</p>
                <p class="font-bold mb-2">Subtítulo - 16px</p>
                <p class="text-xl font-bold">Subtítulo - 20px</p>
            </div>

            <div>
                <p class="text-xl font-bold mb-2">Título - 20px</p>
                <p class="text-2xl font-bold mb-2">Título - 24px</p>
                <p class="text-3xl font-bold">Título - 32px</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>